import {Component, EventEmitter, HostListener, OnInit, Output} from '@angular/core';
import {Subject} from 'rxjs';
import {DwtService} from 'src/app/share/services/dwt/dwt.service';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { StorageKeys } from '../../share/enums/storage.enum';

@Component({
    selector: 'app-scan-document',
    templateUrl: './scan-document.component.html',
    styleUrl: './scan-document.component.scss',
    standalone: false
})
export class ScanDocumentComponent implements OnInit {
  @Output() closeEvent: EventEmitter<any> = new EventEmitter<any>
  eventsSubject: Subject<void> = new Subject<void>();

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.eventsSubject.next(event);
  }
  bStartUp = true;
  bStartDemo = false;
  bUseCameraViaDirectShow = true;
  companyPrefs: any;

  constructor(
    protected dwtService: DwtService,
    private readonly storageService: StorageService
  ) {
    this.companyPrefs = this.storageService.getDataFromLocalStorage(StorageKeys.PREFERENCES);
    let _this = this;
    if (this.companyPrefs?.documentVault?.scanner && !this.companyPrefs?.['sdex-scanner']?.enabled) {
      this.dwtService.initialize();
    dwtService.showStartDemo(function(bShowStartDemo: any){
      _this.bStartDemo = bShowStartDemo;
   });
    }
  }

  ngOnInit(): void {
    this.bStartUp = !this.bStartUp;
    if (this.companyPrefs?.documentVault?.scanner && !this.companyPrefs?.['sdex-scanner']?.enabled) {
      this.dwtService.bUseCameraViaDirectShow = this.bUseCameraViaDirectShow;
    }
  }

  onCloseIconClick(){
    this.closeEvent.emit();
  }
}
